import * as fromCenter from '../actions/center.actions'
import { FlightNetworkCenterState, CenterStatus } from './flight-network.reducer'
import { createReducer, on, Action } from '@ngrx/store'

export interface State {
  center: FlightNetworkCenterState
  loading: boolean
  error: any
}

export const initialState: State = {
  center: null,
  loading: true,
  error: null,
}

const userReducer = createReducer(
  initialState,
  on(fromCenter.loadCenter, fromCenter.initOpenStateChange, (state) => ({ ...state, loading: true })),

  on(fromCenter.loadCenterSuccess, (state, { center }) => ({
    ...state,
    loading: false,
    center: center && { ...center },
  })),

  on(fromCenter.changeOpenStateSuccess, (state, { open_state, center }) => ({
    ...state,
    center:
      !center || open_state === CenterStatus.Closed
        ? null
        : {
            ...center,
            open_state,
          },
    loading: false,
  })),

  on(fromCenter.loadCenterFailure, fromCenter.initOpenStateChangeFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  on(fromCenter.setCenterSuccess, (state, { center }) => ({
    ...state,
    center,
    loading: false,
  })),
)

export function reducer(state: State | undefined, action: Action): State {
  return userReducer(state, action)
}

export const selectors = {
  getCenter: (state: State) => state.center,
  getCenterStatus(state: State): CenterStatus | null {
    if (state.loading) {
      return null
    }
    return state.center ? state.center.open_state : CenterStatus.Closed
  },
  getCenterLoading: (state: State) => state.loading,
  getCenterVehicle(state: State, props: { vehicle_id: number }) {
    return state && state.center && state.center.vehicles.find((item) => item.id === props.vehicle_id)
  },
}
